<!-- <div>{{xctFormHelper.debugIdentifier()}}</div> -->
<button (click)="eventButtonClicked()" class="xct-button btn btn-link">
  @if (iconClasses) {
    <i class="{{ iconClasses }}"></i>
  }
  {{ labelText }}
</button>
